import SingleSelectBox from "../../../components/FormComponents/SingleSelectBox";
import Input from "../../../components/FormComponents/Input";

const UserLogsFilterSection = ({
  filters,
  logTypeOptions,
  userOptions,
  onTypeChange,
  onUserSelect,
  onUserSearch,
  onDateChange,
  toLocalDatetimeString,
  toUTCISOString
}) => {
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
        gap: "12px",
        padding: "12px 0px",
        borderRadius: "6px"
      }}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
        <label className="builder_label">Log Type</label>
        <select className="builder_input w_100" value={filters.type || ""} onChange={onTypeChange}>
          <option value="">All Types</option>
          {logTypeOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
        <label className="builder_label">User Email</label>
        <SingleSelectBox
          options={userOptions}
          valueKey="email"
          labelKey={["email"]}
          selectedData={filters.user_email || ""}
          placeholder="Filter by user email"
          isSearch
          isApiSearch
          apiCallback={onUserSearch}
          onChange={onUserSelect}
        />
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
        <label className="builder_label">From Date</label>
        <Input
          inputBoxStyle={{ height: "30px" }}
          type="datetime-local"
          value={toLocalDatetimeString(filters.from_date)}
          onChange={(e) => onDateChange("from_date", toUTCISOString(e.target.value))}
        />
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
        <label className="builder_label">To Date</label>
        <Input
          inputBoxStyle={{ height: "30px" }}
          type="datetime-local"
          value={toLocalDatetimeString(filters.to_date)}
          onChange={(e) => onDateChange("to_date", toUTCISOString(e.target.value))}
        />
      </div>
    </div>
  );
};

export default UserLogsFilterSection;
